//temp randomization of lat/long for mocking data
function getRandomInRange(from, to, fixed) {
    return (Math.random() * (to - from) + from).toFixed(fixed) * 1;
    // .toFixed() returns string, so ' * 1' is a trick to convert to number
}

function adaptMockItemObj(item, id, type) {
    const TEMP_ITEM = {
        lat: getRandomInRange(-50, 50, 3),
        long: getRandomInRange(-135, 135, 3)
    };

    item = {
        id: type + "_" + id,
        type: "Feature",
        geometry: {
            type: "Point",
            coordinates: [TEMP_ITEM.long, TEMP_ITEM.lat]
        },
        properties: {
            ...item,
            lastHeard: Date.now(),
            activeAlarmCount: 0,
            createDate: Date.now(),
            id: id,
            highestActiveAlarmSeverity: "SEV10"
        }
    };

    // mock some data for the map to display them correctly
    if (type === "tower") {
        item.properties.baseStationId = id;
        item.properties.stats = {};
    } else if (type === "radio") {
        item.properties.repId = id;
        item.properties.deviceType = null;
        item.properties.firmwareVersion = null;
    }

    return item;
}

function getLocationFromItem(location, useEstimated = false) {
    return (location && location.gps ? {
                long: useEstimated ? location.gps.longitudeCalc : location.gps.longitude,
                lat: useEstimated ? location.gps.latitudeCalc : location.gps.latitude
            }
            : {
                long: 0,
                lat: 0
            }
    )
}

function adaptItemObj(item, id) {
    // validate the location of the item, use the estimated lat/long if need be
    let loc = getLocationFromItem(item.location);

    if (loc.lat && loc.lat > -90 && loc.lat < 90 && loc.long && loc.long >-180 && loc.long < 180) {
        // valid lat long
        loc.estimatedLatLong = false;
    } else {
        // see if we can use estimated lat/long
        if (item.location && item.location.gps && item.location.gps.longitudeCalc && item.location.gps.latitudeCalc) {
            loc = getLocationFromItem(item.location,true);
            loc.estimatedLatLong = true;
        }
    }

    item = {
        id: id,
        type: "Feature",
        geometry: {
            type: "Point",
            estimatedLatLong: loc.estimatedLatLong,
            coordinates: [loc.long || 0, loc.lat || 0]
        },
        properties: {
            ...item
        }
    };

    // remove the location object from the item now that we have a geometry geojson object
    //delete item.properties.location;

    return item;
}

export default function (items, isMocked = false, type) {
    //REACTIVE DATA
    //ENTITY:
    //towers loads 5000 but dies when trying to use grouping controls
    //towers loads 2500 but a bit slow with controls. seems to be ok. test a bit more
    //towers load 3000, about 4 seconds to load data
    //towers loads 4000, but also shits teh bed when trying selecting or grouping

    //PRIMITIVE POINTS
    //100,000 loads, but starts to cause memory problems
    //50,000 loads and works fine
    // 75,000 is right around the sweet spot

    //NON REACTIVE DATA
    //ENTITY
    //loads 1k fast
    //loads 5k fast
    //towers loads 10,000 but a bit slow
    //towers load 20,000 but a bit slow
    //tower loads 40,000, but a bit slow. multi select is fast
    //tower oads 50,000, but starts to drag. potential memory crash warnings
    //towers entities crashes at 80,000 - might be able to do more with primative billboard

    //PRIMITIVE POINTS
    //100k is snappy!
    //250k is still pretty good in chrome
    //350k still ok
    //400k performance on UI starts to slip
    //500k - 2000k is slow, but doable

    if (isMocked) {
        let scaleNumber = 50000;
        let aggregator = [scaleNumber];
        let numWorkers = 100;
        let workers = [numWorkers];

        for (let i = 0; i < workers.length; i++) {
            workers[i] = i;
        }

        return new Promise((resolve, reject) => {
            Promise.all(
                workers.map((worker, index) => {
                    return new Promise((resolve, reject) => {
                        let partNum = scaleNumber / numWorkers;
                        let partitionStart = partNum * index;
                        let partTotal = partNum * (index + 1);

                        for (let i = partitionStart; i < partTotal; i++) {
                            aggregator[i] = adaptMockItemObj(items[i % items.length], i, type);
                        }

                        resolve();
                    });
                })
            ).then(() => {
                resolve(aggregator);
            });
        });

    } else {
        return new Promise((resolve, reject) => {
            resolve(
                items.map((item, index) => {
                    let id = type + "_" + index;
                    // if we have a tower or radio then use the baseStationId or repId as part of the id
                    if (type === "tower") {
                        id = type + "_" + item.baseStationId;
                    } else if (type === "radio") {
                        id = type + "_" + item.repId;
                    }
                    return adaptItemObj(item, id);
                })
            );
        });
    }
}
